import { energySymbols } from '../Energy/energySymbols';

/**
 * The energy a retreat has to discard when there's no choice: the cost takes all the energy the Pokémon has
 * (counted as the cost counts it, so a Double Colorless is two), so all of it goes. Null when there's a choice, or
 * nothing to pay.
 *
 * @param {List} energyAttachments the retreating Pokémon's energy cards
 * @param {number} retreatCost
 * @returns {number[]|null} the attachments' ids
 */
export function forcedEnergy(energyAttachments, retreatCost) {
  if (retreatCost <= 0 || !energyAttachments || !energyAttachments.size) {
    return null;
  }
  return energySymbols(energyAttachments).size <= retreatCost
    ? energyAttachments.map(attachment => attachment.get('id')).toArray()
    : null;
}
